import { render } from "./Direct_Receipt.vue?vue&type=template&id=3f66650b"
import script from "./Direct_Receipt.vue?vue&type=script&lang=js"
export * from "./Direct_Receipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__